
import React from 'react';
import { Card,Button,Empty} from "antd"
import RegisterPermissionLetterInstitute from "./RegisterPermissionLetter/RegisterPermissionLetterInstitute"
import ViewerPDF from "./../../Layouts/PDF/Viewer/ViewerPDF"
import { useState,useMemo } from "react"
import { useCallback } from "react";
import { useEffect } from "react";
import InstituteService from "../../../services/InstituteService";
import { useLocation,useHistory,useParams } from "react-router-dom"
import { useSelector } from 'react-redux';
import { selectUser } from '../../../Auth/userReducer';



export default function PermissionInstitute(Props) {
    const user= useSelector(selectUser)
    const {Institute}=Props
    const [viewModal,setViewModal]=useState(false);
    const [modalOption,setModalOption]=useState(false);
    const [documentApprovalPDF,setDocumentApprovalPDF]=useState()
    const [displayViewerPDF,setDisplayViewerPDF]=useState(false)
    const {id:InstituteID}=useParams()
    // const [filePDF,setFilePDF]=useState(null)
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );

    const [isUploadPDF,setIsUploadPDF]=useState(false)
    const [permissionComponents,setPermissionComponents]=useState(false)
    const RolesPermited=[
        "Coordinador del instituto",
    ]
    const propsModal={
        open:viewModal,
        // onCancel:()=>{setViewModal(false)},
        // onOk:(file)=>createPermissionLetterCenter(file)
        footer:null,
    }
    
    const propsOptions={
        onCancel:()=>{setViewModal(false)},

    }

    const getDocumentApproval=useCallback((instituteId)=>{
        InstituteService.getDocumentApprovalByInstitute(instituteId).then((res)=>{
            let DocumentApprovalPDF=res.data?.response
            setDocumentApprovalPDF(DocumentApprovalPDF)
            setDisplayViewerPDF(DocumentApprovalPDF===undefined? true:false)
            // setFilePDF(DocumentApprovalPDF?.documentApprovalAttachment)
        })
    })  

    const verificityPermissionRol=()=>{
        console.log("user.rolName",user.rolName)
        return RolesPermited.includes(user.rolName)
    }
    const updatedPDF=(response)=>{
        setIsUploadPDF(response);
    }
    useEffect(()=>{
            if (searchParams.get('option')!=="PermissionLetter") {
                searchParams.set('option', 'PermissionLetter');
                history.replace({ search: searchParams.toString() });
            }
        setPermissionComponents(verificityPermissionRol())  
        getDocumentApproval(InstituteID)
        setIsUploadPDF(false)
    },[isUploadPDF])
    
    
    return(
    <>
        {permissionComponents  &&
        (<Card>
            { displayViewerPDF?
            <Button onClick={()=>{
                setViewModal(true)
                setModalOption("create")
            }}
            >Subir PDF</Button>
            :
            <Button onClick={()=>{
                setViewModal(true)
                setModalOption("update")
            }}
            >Cambiar PDF</Button>
            }
        </Card>)
        }
        <RegisterPermissionLetterInstitute 
        propsModal={propsModal}
        propsOptions={propsOptions}
        propsInstitute={Institute}
        propsIsUploadPDF={updatedPDF}
        propsModalOption={modalOption}
        propsDataUpdate={documentApprovalPDF?.documentApprovalName}
        >
        </RegisterPermissionLetterInstitute>
        <Card>
        {displayViewerPDF? 
        <Empty/>:
        <ViewerPDF
        FileName={documentApprovalPDF?.documentApprovalName}
        FileDocument={documentApprovalPDF?.documentApprovalAttachment}
        ></ViewerPDF>
            }
        </Card>
    </>)
}